"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabela = void 0;
var react_1 = __importStar(require("react"));
var TabelaCabecalho_1 = require("./TabelaCabecalho/TabelaCabecalho");
var TabelaCorpo_1 = require("./TabelaCorpo/TabelaCorpo");
var TabelaRodape_1 = require("./TabelaRodape/TabelaRodape");
var emptyDataTable_1 = require("./emptyDataTable");
var estiloTabela = require("./Tabela.module.scss");
var Tabela = function (_a) {
    var colunas = _a.colunas, dados = _a.dados, itensPorPagina = _a.itensPorPagina, totalItens = _a.totalItens, paginaAtual = _a.paginaAtual, _b = _a.showBotaoExportar, showBotaoExportar = _b === void 0 ? false : _b, _c = _a.draggable, draggable = _c === void 0 ? false : _c, onChangePagina = _a.onChangePagina, onChangeItensPorPagina = _a.onChangeItensPorPagina, onClickLinha = _a.onClickLinha, onClickExportar = _a.onClickExportar;
    var dadosOrdenados = (0, react_1.useMemo)(function () {
        var habilitados = dados.filter(function (row) { return !row.desabilitado; });
        var desabilitados = dados.filter(function (row) { return row.desabilitado; });
        return __spreadArray(__spreadArray([], habilitados, true), desabilitados, true);
    }, [dados]);
    var hasData = dadosOrdenados.length > 0;
    return (react_1.default.createElement("div", { className: estiloTabela.tableContainer },
        react_1.default.createElement("table", { className: estiloTabela.table },
            react_1.default.createElement(TabelaCabecalho_1.TabelaCabecalho, { coluna: colunas }),
            hasData ? (react_1.default.createElement(TabelaCorpo_1.TabelaCorpo, { dados: dadosOrdenados, colunas: colunas, onClickLinha: onClickLinha, draggable: draggable })) : (react_1.default.createElement(emptyDataTable_1.EmptyDataTable, { colSpan: colunas.length }))),
        hasData && (react_1.default.createElement(TabelaRodape_1.TabelaRodape, { paginaAtual: paginaAtual, itensPorPagina: itensPorPagina, onChangeItensPorPagina: onChangeItensPorPagina, onChangePagina: onChangePagina, totalItens: totalItens, showBotaoExportar: showBotaoExportar, onClickExportar: onClickExportar }))));
};
exports.Tabela = Tabela;
